export default "__VITE_ASSET__Dg6TOD9l__"